import './App.css';
import { useState } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom/cjs/react-router-dom.min';
import Navbar from './components/Navbar';
import UpperBar from './components/UpperBar';
import Footer from './components/Footer';
import Speaking from './components/Speaking';
import TalkAbMe from './components/TalkAbMe';
import Collage from './components/Collage';
import Contact from './components/Contact';
import Consulting from './components/Consulting';
import MyViedo from './components/MyViedo';
import MyPoadcast from './components/MyPoadcast';
import FreeResource from './components/FreeResource';
import Whatapp from './components/Whatapp';
import OurCoures from './components/OurCoures';
import TermandCondi from './components/TermandCondi';
import Pandp from './components/pandp';
import Refund from './components/Refund';
import Home from './components/Home';
import StoryMain from './components/StoryMain';
import ExpertiseMain from './components/ExpertiseMain';
import PopUp from './components/PopUp';
import Result from './components/Result';
import CaseStudyPage2 from './components/CaseStudyPage2';
import LandingPage from './components/LandingPage';



function App() {
  const [showPopup, setShowPopup] = useState(true);

  const handleClose = () => {
    setShowPopup(false);
  };
  return (
    <>
      <UpperBar />
      <Navbar />
      <Router>
        <Switch>
          <Route exact path='/'>
            <Home />
          </Route>
          <Route path='/MyStory'>
            <StoryMain />
          </Route>
          <Route path='/Speaking'>
            <Speaking />
            <TalkAbMe />
            <Collage />
            <ExpertiseMain />
          </Route>
          <Route path='/OurCourses'>
            <PopUp show={showPopup} handleClose={handleClose} />
            <OurCoures />
          </Route>
          <Route path='/OurCourse/MyVideos'>
            <MyViedo />
          </Route>
          <Route path='/OurCourse/MyPoadcast'>
            <MyPoadcast />
          </Route>
          <Route path='/OurCourse/FreeResource'>
            <FreeResource />
          </Route>
          <Route path='/CaseStudy'>
            <Result />
          </Route>
          <Route path='/CaseStudy-2'>
            <CaseStudyPage2 />
          </Route>
          <Route path='/BusinessConsulting'>
            <Consulting />
          </Route>
          <Route path='/ContactUs'>
            <Contact />
          </Route>
          <Route path='/Terms-And-Conditions'>
            <TermandCondi />
          </Route>
          <Route path='/Privacy-Policy'>
            <Pandp />
          </Route>
          <Route path='/Return-And-Refund-Policy'>
            <Refund />
          </Route><Route path='/UmangRataniLandingPage'>
            <LandingPage />
          </Route>
        </Switch>
      </Router>
      <Whatapp />
      <Footer />
    </>
  );
}

export default App;
